import type { ChatStep } from '../../../types/stream.types';
import type { ToolRenderer, ToolSummary, ToolContent } from './tool-renderer.types';
import React from 'react';

export class ThoughtStepRenderer implements ToolRenderer {
  getSummary(step: ChatStep, _isStreaming: boolean): ToolSummary {
    const message = step.message || '';
    const preview = message.substring(0, 60).trim();

    return {
      text: preview || 'Thinking...',
    };
  }

  getContent(step: ChatStep): ToolContent {
    const message = step.message || '';

    return {
      main: (
        <div className="text-xs text-gray-500 leading-relaxed whitespace-pre-wrap">
          {message}
        </div>
      ),
    };
  }
}
